import PropTypes from "prop-types";
import { memo } from "react";
import classNames from "classnames";

const AirlineLogo = ({
	airlineCode,
	width = 132,
	height = 40,
	fit = "fit",
	quality = "auto",
	className = "",
	alt = "",
	loading = "lazy",
	...props
}) => {
	const buildUrl = dpr =>
		`https://res.cloudinary.com/perfectstay/image/upload/c_${fit},w_${width},h_${height},dpr_${dpr},f_auto,q_${quality}/v1/airline/${airlineCode}`;

	return (
		<img
			className={classNames("airline-logo", className)}
			src={buildUrl("1.0")}
			srcSet={`${buildUrl("1.0")} 1x, ${buildUrl("2.0")} 2x`}
			alt={alt}
			loading={loading}
			{...props}
		/>
	);
};

AirlineLogo.propTypes = {
	airlineCode: PropTypes.string.isRequired,
	width: PropTypes.number,
	height: PropTypes.number,
	fit: PropTypes.string,
	quality: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	className: PropTypes.string,
	alt: PropTypes.string,
	loading: PropTypes.oneOf(["lazy", "eager"]),
};

export default memo(AirlineLogo);
